// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"9c2b4b03","453":"76008dec"}[chunkId] + ".chunk.js";
};